import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';

import { usePageHeader } from '@/contexts/PageHeaderContext';
import { Button } from '@/components/ui/button';
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle
} from '@/components/ui/card';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger
} from '@/components/ui/alert-dialog';

export function SettingsPage() {
	const { t } = useTranslation('settings');
	const { setPageHeader, resetPageHeader } = usePageHeader();

	useEffect(() => {
		setPageHeader({
			title: t('page.title'),
			description: t('page.description')
		});

		return () => {
			resetPageHeader();
		};
	}, [t, setPageHeader, resetPageHeader]);

	const handleResetLocalStorage = () => {
		localStorage.clear();
		toast.success(t('resetStorage.toastSuccess'));
		setTimeout(() => {
			window.location.href = '/';
		}, 1000);
	};

	return (
		<div className="flex flex-col gap-6 p-6 max-w-3xl mx-auto">
			<Card>
				<CardHeader>
					<CardTitle>{t('resetStorage.title')}</CardTitle>
					<CardDescription>
						{t('resetStorage.description')}
					</CardDescription>
				</CardHeader>
				<CardContent>
					<AlertDialog>
						<AlertDialogTrigger asChild>
							<Button variant="destructive">
								<Trash2 className="mr-2 h-4 w-4" />
								{t('resetStorage.resetButton')}
							</Button>
						</AlertDialogTrigger>
						<AlertDialogContent>
							<AlertDialogHeader>
								<AlertDialogTitle>
									{t('resetStorage.confirmTitle')}
								</AlertDialogTitle>
								<AlertDialogDescription>
									{t('resetStorage.confirmDescription')}
								</AlertDialogDescription>
							</AlertDialogHeader>
							<AlertDialogFooter>
								<AlertDialogCancel>
									{t('resetStorage.cancel')}
								</AlertDialogCancel>
								<AlertDialogAction
									className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
									onClick={handleResetLocalStorage}
								>
									{t('resetStorage.confirm')}
								</AlertDialogAction>
							</AlertDialogFooter>
						</AlertDialogContent>
					</AlertDialog>
				</CardContent>
			</Card>
		</div>
	);
}
